export const SET_ACTIVE_PORTFOLIO:string = 'SET_ACTIVE_PORTFOLIO';
export const DISCARD_ACTIVE_PORTFOLIO:string = 'DISCARD_ACTIVE_PORTFOLIO';

// used for ajax calls to server
export const GET_PORTFOLIOS:string = 'GET_PORTFOLIOS';
export const GET_PORTFOLIOS_SUCCESS:string = 'GET_PORTFOLIOS_SUCCESS';

export const GET_PORTFOLIO:string = 'GET_PORTFOLIO';
export const GET_PORTFOLIO_AND_REDIRECT:string = 'GET_PORTFOLIO_AND_REDIRECT';
export const GET_PORTFOLIO_SUCCESS:string = 'GET_PORTFOLIO_SUCCESS';

export const GET_PORTFOLIO_CONFIG:string = 'GET_PORTFOLIO_CONFIG';
export const GET_PORTFOLIO_CONFIG_SUCCESS:string = 'GET_PORTFOLIO_CONFIG_SUCCESS';

export const SAVE_PORTFOLIO:string = 'SAVE_PORTFOLIO';
export const SAVE_PORTFOLIO_SUCCESS:string = 'SAVE_PORTFOLIO_SUCCESS';
export const COPY_PORTFOLIO:string = 'COPY_PORTFOLIO';

export const UPDATE_PORTFOLIO_LIST:string = 'UPDATE_PORTFOLIO_LIST';
export const INSERT_PORTFOLIO_TO_STORE:string = 'INSERT_PORTFOLIO_TO_STORE';

export const PORTFOLIO_API_ERROR:string = 'PORTFOLIO_API_ERROR';
export const PORTFOLIO_API_ERROR_CLEAR:string = 'PORTFOLIO_API_ERROR_CLEAR';